
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import DateField from "@/components/utils/DateField.vue";
import i18n from "@/plugins/vue-i18n";
import SidebarPanier from "@/components/panier/SidebarPanier.vue";
import comptageService from "@/services/comptage.service";

@Component({
    components: {SidebarPanier, DateField}
})
export default class NumberFilter extends Vue {

    @Prop() readonly field;
    @Prop() readonly date: boolean;
    @Prop() readonly lastYear: boolean;
    @Prop() readonly canBeNegative: boolean;
    @Prop() readonly min;
    @Prop() readonly max;
    @Prop() readonly value;
    radioGroup = 1;
    currentValue = '';
    currentMin = '';
    currentMax = '';
    errorValueMessage = null;
    errorRangeMessage = null;
    displayMessage = null;
    timer;
    futurRadioGroup = 2;



    created() {
      this.currentValue = this.value;
      this.currentMin = this.min;
      this.currentMax = this.max;
      this.checkRadioButton();
      const keyNumberMap = comptageService.keyNumbersMap();
      if (keyNumberMap[this.field].type === 'number') {
        this.displayMessage = comptageService.getKeyNumbersRangeSentence(this.field, this.currentMin, this.currentMax);
      } else {
        this.displayMessage = comptageService.getKeyNumbersRangeSentence(this.field, this.parseDate(this.currentMin), this.parseDate(this.currentMax));
      }
    }

    parseDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}-${month.padStart(2, '0')}-${year.padStart(2, '0')}`;
    }

    numberComas(number){
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    checkRadioButton() {
        this.radioGroup = this.futurRadioGroup;
    }

    @Watch("value", {deep: true})
    changeDisplayValue() {
      const keyNumberMap = comptageService.keyNumbersMap();
        if (this.currentValue && !this.value) {

          if (keyNumberMap[this.field].type === 'number') {
            this.currentValue = this.value;
          } else {
            this.currentValue = this.parseDate(this.value);
          }
            this.displayMessage = null;
            this.radioGroup = 1;
        } else {
            if (keyNumberMap[this.field].type === 'number') {
              this.currentValue = this.value;
            } else {
              this.currentValue = this.parseDate(this.value);
            }
            this.checkRadioButton();
        }
    }

    @Watch("min", {deep: true})
    changeDisplayMin() {
        this.currentMin = this.min;
        this.checkRadioButton();
        if (!this.currentMin && !this.currentMax) {
            this.displayMessage = null;
            this.radioGroup = 1;
        }
    }

    @Watch("max", {deep: true})
    changeDisplayMax() {
        this.currentMax = this.max;
        this.checkRadioButton();
        if (!this.currentMin && !this.currentMax) {
            this.displayMessage = null;
            this.radioGroup = 1;
        }
    }

    validationValue() {
        this.errorValueMessage = null;
        this.displayMessage = null;
        if (this.currentValue) {
            clearTimeout(this.timer);
            this.currentMin = null;
            this.currentMax = null;
            const keyNumberMap = comptageService.keyNumbersMap();
            if (keyNumberMap[this.field].type === 'number') {
                if (Number(this.currentValue) < 0 && !this.canBeNegative) {
                    this.timer = setTimeout(() => {
                        this.errorValueMessage = i18n.tc('greater_than_zero');
                        this.displayMessage = null;
                    }, 1000);
                    return;
                } else {
                  this.displayMessage = comptageService.getKeyNumbersValueSentence(this.field, this.numberComas(this.currentValue));
                  this.$emit('return', this.field, 'value', this.currentValue);
                }
            } else {
                this.timer = setTimeout(() => {
                    this.displayMessage = comptageService.getKeyNumbersValueSentence(this.field, this.parseDate(this.currentValue));
                },1000);
                this.$emit('return', this.field, 'value', this.currentValue);
            }
        }
    }

    validationRange() {

        this.currentMin = this.currentMin === null ? undefined : this.currentMin;
        this.currentMax = this.currentMax === null ? undefined : this.currentMax;

        this.errorRangeMessage = null;
        this.displayMessage = null;
        if (this.currentMin || this.currentMax) {
            clearTimeout(this.timer);
            this.currentValue = null;
            const keyNumberMap = comptageService.keyNumbersMap();
            if (this.currentMin) {
                if (keyNumberMap[this.field].type === 'number') {
                    if (Number(this.currentMin) < 0 && !this.canBeNegative) {
                        this.timer = setTimeout(() => {
                            this.errorRangeMessage = i18n.tc('greater_than_zero');
                            this.displayMessage = null;
                        }, 1000);
                        return;
                    } else {
                      this.displayMessage = comptageService.getKeyNumbersRangeSentence(this.field,  this.numberComas(this.currentMin), "");
                    }
                }
            }
            if (this.currentMax) {
              if (keyNumberMap[this.field].type === 'number') {
                if (Number(this.currentMax) < 0 && !this.canBeNegative) {
                  this.timer = setTimeout(() => {
                    this.errorRangeMessage = i18n.tc('greater_than_zero');
                    this.displayMessage = null;
                  }, 1000);
                  return;
                } else {
                  this.displayMessage = comptageService.getKeyNumbersRangeSentence(this.field, "", this.numberComas(this.currentMax));
                }
              }
            }
            if (this.currentMax && this.currentMin) {
                if (keyNumberMap[this.field].type === 'number') {
                    if (Number(this.currentMin) >= Number(this.currentMax)) {
                        this.timer = setTimeout(() => {
                            this.errorRangeMessage = i18n.tc('min_greater_than_max');
                            this.displayMessage = null;
                        }, 1000);
                        return;
                    } else {
                      this.displayMessage = comptageService.getKeyNumbersRangeSentence(this.field, this.numberComas(this.currentMin), this.numberComas(this.currentMax));
                    }
                } else {
                    const dateMin = new Date(this.currentMin);
                    const dateMax = new Date(this.currentMax);
                    if (dateMin.getTime() >= dateMax.getTime()) {
                        this.timer = setTimeout(() => {
                            this.errorRangeMessage = i18n.tc('mindate_after_maxdate');
                        }, 1000);
                        return;
                    }
                }
            }
          this.timer = setTimeout(() => {
            this.displayMessage = comptageService.getKeyNumbersRangeSentence(this.field, this.parseDate(this.currentMin), this.parseDate(this.currentMax));
          }, 1000);
        }
        this.$emit('return', this.field, 'both', this.currentMin, this.currentMax);
    }

    setLastYear() {
        this.currentValue = null;
        const currentDate = new Date();
        this.currentMax = currentDate.getFullYear() + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2)+ '-' + ('0' + currentDate.getDate()).slice(-2);
        this.$emit('return', this.field, 'max', this.currentMax);
        this.currentMin = (currentDate.getFullYear() - 1) + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2)  +  '-' + ('0' + currentDate.getDate()).slice(-2);
        this.$emit('return', this.field, 'both', this.currentMin, this.currentMax);
        this.displayMessage = comptageService.getKeyNumbersRangeSentence(this.field, this.currentMin, this.currentMax);
    }

}
